/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IXERC20, IXERC20Interface } from "../IXERC20";

const _abi = [
  {
    inputs: [],
    name: "IXERC20_LimitsTooHigh",
    type: "error",
  },
  {
    inputs: [],
    name: "IXERC20_NotFactory",
    type: "error",
  },
  {
    inputs: [],
    name: "IXERC20_NotHighEnoughLimits",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_mintingLimit",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_burningLimit",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_bridge",
        type: "address",
      },
    ],
    name: "BridgeLimitsSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_lockbox",
        type: "address",
      },
    ],
    name: "LockboxSet",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lockbox",
        type: "address",
      },
    ],
    name: "setLockbox",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bridge",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_mintingLimit",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_burningLimit",
        type: "uint256",
      },
    ],
    name: "setLimits",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_minter",
        type: "address",
      },
    ],
    name: "mintingMaxLimitOf",
    outputs: [
      {
        internalType: "uint256",
        name: "_limit",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bridge",
        type: "address",
      },
    ],
    name: "burningMaxLimitOf",
    outputs: [
      {
        internalType: "uint256",
        name: "_limit",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_minter",
        type: "address",
      },
    ],
    name: "mintingCurrentLimitOf",
    outputs: [
      {
        internalType: "uint256",
        name: "_limit",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bridge",
        type: "address",
      },
    ],
    name: "burningCurrentLimitOf",
    outputs: [
      {
        internalType: "uint256",
        name: "_limit",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IXERC20__factory {
  static readonly abi = _abi;
  static createInterface(): IXERC20Interface {
    return new utils.Interface(_abi) as IXERC20Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IXERC20 {
    return new Contract(address, _abi, signerOrProvider) as IXERC20;
  }
}
